// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --mat-dialog-headline-padding: 25px 25px 0;
}

.dialog-content {
  height: calc(100% - 104px);
  overflow: hidden;
}

.btn-form {
  color: var(--primary);
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  z-index: 5;
  margin-left: 10px;
}

.btn-form:disabled {
  cursor: not-allowed;
  border: 1px solid rgb(218, 218, 218);
}

.border-right {
  border-right: 1px solid rgb(219, 219, 219);
}

.tag-control-container {
  margin: 6px 0 0 12px;
  padding: 12px 6px;
  border-radius: 4px;
  box-shadow:  rgba(0, 0, 0, 0.2),  rgba(0, 0, 0, 0.14),  rgba(0, 0, 0, 0.12);
  border: 1px solid rgb(218, 218, 218);
}

.tags-container {
  height: calc(100% - 10px);
  overflow-y: auto;
}

.scope-container {
  height: calc(100% - 12px);
  width: calc(35% - 12px);
  padding-left: 12px;
}
.scope-container .scope-content {
  width: 100%;
  height: calc(100% - 72px);
  padding-left: 12px;
  overflow-y: auto;
}

.retrieve-container {
  width: 100%;
  padding-top: 12px;
  text-align: center;
}

.border-bottom {
  border: none !important;
  border-bottom: 1px solid var(--primary);
}

.widget-input {
  border: none;
  border-bottom: solid 1px #dedede !important;
  font-size: 20px;
  width: 100%;
}

.mat-mdc-chip.mat-mdc-standard-chip {
  background-color: var(--primary);
  color: #ffffff;
  min-height: 20px;
}

.mat-mdc-standard-chip .mat-mdc-chip-remove.mat-mdc-icon, .mat-mdc-standard-chip .mat-mdc-chip-remove .mat-mdc-icon {
  width: 12px;
  height: 12px;
  font-size: 14px;
  color: #ffffff;
  opacity: 1;
}

.mat-mdc-chip-list-wrapper input.mat-mdc-input-element, .mat-mdc-chip-list-wrapper .mat-mdc-standard-chip {
  margin: 2px !important;
}

.delete-icon {
  position: absolute;
  left: -12px;
  top: 12px;
}

.flex-head {
  background: rgb(204, 204, 204);
  height: 40px;
}
.flex-head > .row {
  min-height: 45px;
}

.flex-body {
  height: 70vh;
  min-height: 360px;
  max-height: 500px;
  overflow-y: hidden;
}
.flex-body .flex-body-content {
  position: absolute;
  height: 100%;
  width: 100%;
}
.flex-body .trend-builder-sidebar {
  border-right: 1px solid var(--line);
}
.flex-body .footer-container {
  flex-shrink: 0;
}
.flex-body .chart-container {
  flex: 1 1 auto;
  max-height: 100%;
}

.trend-builder-content {
  position: relative;
  max-height: 100%;
}
.trend-builder-content .loader {
  position: absolute;
  z-index: 4;
  width: 97%;
  opacity: 0.55;
  background-color: #fafafa;
  padding-right: 15px;
  padding-left: 15px;
}

.btn-group .btn {
  border: 1px solid var(--line);
  border-radius: 0px;
}
.btn-group .btn.btn-outline-primary {
  color: var(--primary);
  border-color: var(--primary) !important;
}
.btn-group .btn.btn-outline-primary.disabled {
  color: var(--gray);
  border-color: var(--gray) !important;
  cursor: default;
}
.btn-group .btn:hover {
  background-color: rgba(var(--primary-rgb), 0.09) !important;
}
.btn-group .btn + .btn {
  border: 1px solid var(--line);
  margin-left: 0px;
  border-radius: 0px;
}
.btn-group .btn + .btn:not(.btn-outline-primary) {
  border-left: 0px;
}

.lbl {
  color: #999;
  font-weight: 700;
  font-size: 11px;
}

ul {
  max-height: 100%;
  margin-bottom: 10px;
  padding-right: 8px;
}
ul::-webkit-scrollbar {
  width: 4px;
  height: 0;
}

.group .head {
  border-bottom: 1px solid var(--line);
  padding: 5px 0px;
  font-size: 14px !important;
}
.group .head.expanded {
  border-bottom: 0px solid var(--line);
}
.group .head:hover {
  cursor: pointer;
}
.group .node-content {
  transition: height 0.5s;
  height: 0;
  overflow: hidden;
}
.group .node-content ul {
  margin-top: -10px;
}
.group .node-content ul li:hover {
  cursor: pointer;
  background-color: #F0E3DE !important;
}
.group .node-content.expanded {
  height: auto;
  padding-top: 10px;
  overflow-y: auto;
}
.group .node-content.expanded::-webkit-scrollbar {
  width: 0px;
  height: 0;
  -webkit-transition: height 0.15s ease-out;
  transition: height 0.15s ease-out;
}

.li-selected {
  background-color: #FDEFEA !important;
}

.border-right {
  border-right: 1px solid var(--line);
}

.h-100 {
  height: 100%;
  max-height: 100%;
}

.node {
  padding: 4px 10px;
  border-radius: 2px;
  color: #333;
  font-size: 13px;
}
.node.selected {
  background-color: rgba(var(--primary-rgb), 0.09) !important;
}
.node.selected:hover {
  background-color: rgba(var(--primary-rgb), 0.09) !important;
  cursor: pointer;
}

.retrieve-btn {
  margin: auto auto 0 auto;
  position: relative;
  top: 10px;
}

.points-config-container {
  width: 100%;
  height: 42px;
  padding-top: 10px;
  align-items: center;
}

.points-container {
  height: calc(100% - 76px);
  padding-left: 12px;
  overflow-y: auto;
}
.points-container .point {
  cursor: pointer;
}
.points-container .selected {
  background-color: #FDEFEA !important;
}

:host ::ng-deep .mdc-radio {
  --mdc-radio-state-layer-size: 16 px !important ;
}

:host ::ng-deep .mat-mdc-radio-container {
  height: 16px;
  width: 16px;
}

:host ::ng-deep .mat-mdc-radio-outer-circle {
  height: 16px;
  width: 16px;
}

:host ::ng-deep .mdc-radio__background {
  height: 16px !important;
  width: 16px !important;
}

:host ::ng-deep .mdc-radio__inner-circle {
  --mdc-radio-selected-icon-color: var(--primary) !important;
  border-width: 8px !important;
}

:host ::ng-deep .mat-mdc-radio-button .mat-mdc-radio-ripple {
  height: 16px; /*double of your required circle radius*/
  width: 16px; /*double of your required circle radius*/
  left: calc(50% - 16px); /*'10px'-same as your required circle radius*/
  top: calc(50% - 16px); /*'10px'-same as your required circle radius*/
}

:host ::ng-deep .mat-mdc-button {
  text-transform: uppercase !important;
  font-size: 14px !important;
}

:host ::ng-deep .mdc-checkbox {
  --mdc-checkbox-state-layer-size: 16px ;
}

.points-ctnr {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/auto-cx/components/auto-cx-dialogs/custom-trend-chart/custom-trend-chart.component.scss","webpack://./node_modules/@angular/material/core/style/_elevation.scss"],"names":[],"mappings":"AAEA;EACE,0CAAA;AADF;;AAGA;EACE,0BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,oCAAA;AAAF;;AAGA;EACE,0CAAA;AAAF;;AAGA;EACE,oBAAA;EACA,iBAAA;EACA,kBAAA;ECkGA,2EAAA;ED/FA,oCAAA;AADF;;AAIA;EACE,yBAAA;EACA,gBAAA;AADF;;AAIA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;AADF;AAGE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AADJ;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,uCAAA;AAFF;;AAIA;EACE,YAAA;EACA,2CAAA;EACA,eAAA;EACA,WAAA;AADF;;AAKA;EACE,gCAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAFF;;AAMA;EACE,8BAAA;EACA,YAAA;AAHF;AAIE;EACI,gBAAA;AAFN;;AAMA;EAEE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAJF;AAME;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AAJN;AAOE;EACI,mCAAA;AALN;AAQE;EACI,cAAA;AANN;AASE;EACI,cAAA;EACA,gBAAA;AAPN;;AAWA;EACE,kBAAA;EACA,gBAAA;AARF;AAUE;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AARN;;AAaE;EACI,6BAAA;EACA,kBAAA;AAVN;AAWM;EACI,qBAAA;EACA,uCAAA;AATV;AAWU;EACI,kBAAA;EACA,oCAAA;EACA,eAAA;AATd;AAYM;EACI,2DAAA;AAVV;AAaE;EACI,6BAAA;EACA,gBAAA;EACA,kBAAA;AAXN;AAaE;EACI,gBAAA;AAXN;;AAeA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAZF;;AAeA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAZF;AAcE;EACE,UAAA;EACA,SAAA;AAZJ;;AAkBE;EACI,oCAAA;EACA,gBAAA;EACA,0BAAA;AAfN;AAgBM;EACI,oCAAA;AAdV;AAgBM;EACI,eAAA;AAdV;AAiBE;EAKI,uBAAA;EACA,SAAA;EACA,gBAAA;AAfN;AAgBM;EACI,iBAAA;AAdV;AAeU;EACE,eAAA;EACA,oCAAA;AAbZ;AAgBM;EACI,YAAA;EACA,iBAAA;EAEA,gBAAA;AAfV;AAgBU;EACI,UAAA;EACA,SAAA;EACA,yCAAA;EAAA,iCAAA;AAdd;;AAoBA;EACE,oCAAA;AAjBF;;AAoBA;EACE,mCAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAjBF;AAkBE;EACI,2DAAA;AAhBN;AAiBM;EACI,2DAAA;EACF,eAAA;AAfR;;AAoBA;EACE,wBAAA;EACA,kBAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,eAAA;AAjBJ;AAoBE;EACE,oCAAA;AAlBJ;;AAqBA;EACE,+CAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,WAAA;AAlBF;;AAoBA;EACE,YAAA;EACA,WAAA;AAjBF;;AAmBA;EACE,uBAAA;EACA,sBAAA;AAhBF;;AAkBA;EACE,0DAAA;EACA,4BAAA;AAfF;;AAiBA;EACE,YAAA,EAAA,wCAAA;EACA,WAAA,EAAA,wCAAA;EACA,sBAAA,EAAA,6CAAA;EACA,qBAAA,EAAA,6CAAA;AAdF;;AAiBA;EACE,oCAAA;EACA,0BAAA;AAdF;;AAiBA;EACE,sCAAA;AAdF;;AAiBA;EACE,eAAA;AAdF","sourcesContent":["@use '@angular/material' as mat;\n\n:host {\n  --mat-dialog-headline-padding: 25px 25px 0;\n}\n.dialog-content {\n  height: calc(100% - 104px);\n  overflow: hidden;\n}\n\n.btn-form {\n  color: var(--primary);\n  background: #ffffff;\n  border-radius: 4px;\n  cursor: pointer;\n  z-index: 5;\n  margin-left: 10px;\n}\n\n.btn-form:disabled {\n  cursor: not-allowed;\n  border: 1px solid rgb(218, 218, 218);\n}\n\n.border-right {\n  border-right: 1px solid rgb(219, 219, 219);\n}\n\n.tag-control-container {\n  margin: 6px 0 0 12px;\n  padding: 12px 6px;\n  border-radius: 4px;\n  // background-color: #f7f7f7;\n  @include mat.elevation(.5);\n  border: 1px solid rgb(218, 218, 218);\n}\n\n.tags-container {\n  height: calc(100% - 10px);\n  overflow-y: auto;\n}\n\n.scope-container {\n  height: calc(100% - 12px);\n  width: calc(35% - 12px);\n  padding-left: 12px;\n\n  .scope-content {\n    width: 100%;\n    height: calc(100% - 72px);\n    padding-left: 12px;\n    overflow-y: auto;\n  }\n}\n\n.retrieve-container {\n  width: 100%;\n  padding-top: 12px;\n  text-align: center;\n}\n\n.border-bottom {\n  border: none !important;\n  border-bottom: 1px solid var(--primary);\n}\n.widget-input {\n  border:none;\n  border-bottom: solid 1px #dedede !important;\n  font-size: 20px;\n  width: 100%;\n \n}\n\n.mat-mdc-chip.mat-mdc-standard-chip {\n  background-color: var(--primary);\n  color: #ffffff;\n  min-height: 20px;\n}\n\n.mat-mdc-standard-chip .mat-mdc-chip-remove.mat-mdc-icon, .mat-mdc-standard-chip .mat-mdc-chip-remove .mat-mdc-icon {\n  width: 12px;\n  height: 12px;\n  font-size: 14px;\n  color: #ffffff;\n  opacity: 1;\n}\n\n.mat-mdc-chip-list-wrapper input.mat-mdc-input-element, .mat-mdc-chip-list-wrapper .mat-mdc-standard-chip {\n  margin: 2px !important;\n}\n\n.delete-icon {\n  position: absolute;\n  left: -12px;\n  top: 12px;\n}\n\n\n.flex-head {\n  background: rgba(204, 204, 204, 1);\n  height: 40px;\n  > .row {\n      min-height: 45px;\n  }\n}\n\n.flex-body {\n\n  height: 70vh;\n  min-height: 360px;\n  max-height: 500px;\n  overflow-y: hidden;\n\n  .flex-body-content {\n      position: absolute;\n      height: 100%;\n      width: 100%;\n  }\n\n  .trend-builder-sidebar {\n      border-right: 1px solid var(--line);\n  }\n\n  .footer-container {\n      flex-shrink: 0;\n  }\n\n  .chart-container {\n      flex: 1 1 auto;\n      max-height: 100%; \n  }\n}\n\n.trend-builder-content {\n  position: relative;\n  max-height: 100%;\n\n  .loader {\n      position: absolute;\n      z-index: 4;\n      width: 97%;\n      opacity: 0.55;\n      background-color: #fafafa;\n      padding-right: 15px;\n      padding-left: 15px;\n  }\n}\n\n.btn-group {\n  .btn {\n      border: 1px solid var(--line);\n      border-radius: 0px;\n      &.btn-outline-primary {\n          color: var(--primary);\n          border-color: var(--primary) !important;\n\n          &.disabled {\n              color: var(--gray);\n              border-color: var(--gray) !important;\n              cursor: default;\n          }\n      }\n      &:hover {\n          background-color:rgba(var(--primary-rgb), 0.09) !important;\n      }\n  }\n  .btn + .btn {\n      border: 1px solid var(--line);\n      margin-left: 0px;\n      border-radius: 0px;\n  }\n  .btn + .btn:not(.btn-outline-primary) {\n      border-left: 0px;\n  }\n}\n\n.lbl {\n  color: #999;\n  font-weight: 700;\n  font-size: 11px;\n}\n\nul {\n  max-height: 100%;\n  margin-bottom: 10px;\n  padding-right: 8px;\n\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 0;\n    // transition: height 0.15s ease-out;\n  }\n}\n\n.group {\n  .head {\n      border-bottom: 1px solid var(--line);\n      padding: 5px 0px;\n      font-size: 14px !important;\n      &.expanded {\n          border-bottom: 0px solid var(--line);\n      }\n      &:hover {\n          cursor: pointer;\n      }\n  }\n  .node-content {\n      -moz-transition: height 0.5s;\n      -ms-transition: height 0.5s;\n      -o-transition: height 0.5s;\n      -webkit-transition: height 0.5s;\n      transition: height 0.5s;\n      height: 0;\n      overflow: hidden;\n      ul {\n          margin-top: -10px;\n          li:hover {\n            cursor: pointer;\n            background-color: #F0E3DE !important;\n          }\n      }\n      &.expanded {\n          height: auto;\n          padding-top: 10px;\n          // max-height: 200px;\n          overflow-y: auto;\n          &::-webkit-scrollbar {\n              width: 0px;\n              height: 0;\n              transition: height 0.15s ease-out;\n          }\n      }\n  }\n}\n\n.li-selected {\n  background-color: #FDEFEA !important;\n}\n\n.border-right {\n  border-right: 1px solid var(--line);\n}\n\n.h-100 {\n  height: 100%;\n  max-height: 100%;\n}\n\n.node {\n  padding: 4px 10px;\n  border-radius: 2px;\n  color: #333;\n  font-size: 13px;\n  &.selected {\n      background-color: rgba(var(--primary-rgb), 0.09) !important;\n      &:hover {\n          background-color: rgba(var(--primary-rgb), 0.09) !important;\n        cursor: pointer;\n      }\n  }\n}\n\n.retrieve-btn {\n  margin: auto auto 0 auto;\n  position: relative;\n  top: 10px;\n}\n\n.points-config-container {\n  width: 100%;\n  height: 42px;\n  padding-top: 10px;\n  align-items: center;\n}\n\n.points-container {\n  height: calc(100% - 76px);\n  padding-left: 12px;\n  overflow-y: auto;\n\n  .point {\n    cursor: pointer;\n  }\n\n  .selected {\n    background-color: #FDEFEA !important;\n  }\n}\n:host ::ng-deep .mdc-radio {\n  --mdc-radio-state-layer-size: 16 px !important\n}\n\n:host ::ng-deep .mat-mdc-radio-container{\n  height: 16px;\n  width: 16px;\n}\n:host ::ng-deep .mat-mdc-radio-outer-circle{\n  height: 16px;\n  width: 16px;\n}\n:host ::ng-deep .mdc-radio__background {\n  height: 16px !important;\n  width: 16px !important;\n}\n:host ::ng-deep .mdc-radio__inner-circle {\n  --mdc-radio-selected-icon-color: var(--primary) !important;\n  border-width: 8px !important;\n}\n:host ::ng-deep .mat-mdc-radio-button .mat-mdc-radio-ripple{\n  height: 16px; /*double of your required circle radius*/\n  width: 16px;  /*double of your required circle radius*/\n  left: calc(50% - 16px); /*'10px'-same as your required circle radius*/\n  top: calc(50% - 16px); /*'10px'-same as your required circle radius*/\n}\n\n:host ::ng-deep .mat-mdc-button {\n  text-transform: uppercase !important;\n  font-size: 14px !important;\n}\n\n:host ::ng-deep .mdc-checkbox {\n  --mdc-checkbox-state-layer-size: 16px\n}\n\n.points-ctnr {\n  font-size: 14px;\n}\n\n","@use 'sass:map';\n@use 'sass:math';\n@use 'sass:meta';\n@use 'sass:string';\n@use './variables';\n@use './sass-utils';\n\n$_umbra-opacity: 0.2;\n$_penumbra-opacity: 0.14;\n$_ambient-opacity: 0.12;\n\n$_umbra-map: (\n  0: '0px 0px 0px 0px',\n  1: '0px 2px 1px -1px',\n  2: '0px 3px 1px -2px',\n  3: '0px 3px 3px -2px',\n  4: '0px 2px 4px -1px',\n  5: '0px 3px 5px -1px',\n  6: '0px 3px 5px -1px',\n  7: '0px 4px 5px -2px',\n  8: '0px 5px 5px -3px',\n  9: '0px 5px 6px -3px',\n  10: '0px 6px 6px -3px',\n  11: '0px 6px 7px -4px',\n  12: '0px 7px 8px -4px',\n  13: '0px 7px 8px -4px',\n  14: '0px 7px 9px -4px',\n  15: '0px 8px 9px -5px',\n  16: '0px 8px 10px -5px',\n  17: '0px 8px 11px -5px',\n  18: '0px 9px 11px -5px',\n  19: '0px 9px 12px -6px',\n  20: '0px 10px 13px -6px',\n  21: '0px 10px 13px -6px',\n  22: '0px 10px 14px -6px',\n  23: '0px 11px 14px -7px',\n  24: '0px 11px 15px -7px',\n);\n\n$_penumbra-map: (\n  0: '0px 0px 0px 0px',\n  1: '0px 1px 1px 0px',\n  2: '0px 2px 2px 0px',\n  3: '0px 3px 4px 0px',\n  4: '0px 4px 5px 0px',\n  5: '0px 5px 8px 0px',\n  6: '0px 6px 10px 0px',\n  7: '0px 7px 10px 1px',\n  8: '0px 8px 10px 1px',\n  9: '0px 9px 12px 1px',\n  10: '0px 10px 14px 1px',\n  11: '0px 11px 15px 1px',\n  12: '0px 12px 17px 2px',\n  13: '0px 13px 19px 2px',\n  14: '0px 14px 21px 2px',\n  15: '0px 15px 22px 2px',\n  16: '0px 16px 24px 2px',\n  17: '0px 17px 26px 2px',\n  18: '0px 18px 28px 2px',\n  19: '0px 19px 29px 2px',\n  20: '0px 20px 31px 3px',\n  21: '0px 21px 33px 3px',\n  22: '0px 22px 35px 3px',\n  23: '0px 23px 36px 3px',\n  24: '0px 24px 38px 3px',\n);\n\n$_ambient-map: (\n  0: '0px 0px 0px 0px',\n  1: '0px 1px 3px 0px',\n  2: '0px 1px 5px 0px',\n  3: '0px 1px 8px 0px',\n  4: '0px 1px 10px 0px',\n  5: '0px 1px 14px 0px',\n  6: '0px 1px 18px 0px',\n  7: '0px 2px 16px 1px',\n  8: '0px 3px 14px 2px',\n  9: '0px 3px 16px 2px',\n  10: '0px 4px 18px 3px',\n  11: '0px 4px 20px 3px',\n  12: '0px 5px 22px 4px',\n  13: '0px 5px 24px 4px',\n  14: '0px 5px 26px 4px',\n  15: '0px 6px 28px 5px',\n  16: '0px 6px 30px 5px',\n  17: '0px 6px 32px 5px',\n  18: '0px 7px 34px 6px',\n  19: '0px 7px 36px 6px',\n  20: '0px 8px 38px 7px',\n  21: '0px 8px 40px 7px',\n  22: '0px 8px 42px 7px',\n  23: '0px 9px 44px 8px',\n  24: '0px 9px 46px 8px',\n);\n\n// A collection of mixins and CSS classes that can be used to apply elevation to a material\n// element.\n// See: https://material.io/design/environment/elevation.html\n// Examples:\n//\n//\n// .mat-foo {\n//   @include $mat-elevation(2);\n//\n//   &:active {\n//     @include $mat-elevation(8);\n//   }\n// }\n//\n// <div id=\"external-card\" class=\"mat-elevation-z2\"><p>Some content</p></div>\n//\n// For an explanation of the design behind how elevation is implemented, see the design doc at\n// https://docs.google.com/document/d/1W3NGSLqDZzjbBBLW2C6y_6NUxtvdZAVaJvg58LY3Q0E/edit\n\n// The default duration value for elevation transitions.\n$transition-duration: 280ms !default;\n\n// The default easing value for elevation transitions.\n$transition-timing-function: variables.$fast-out-slow-in-timing-function;\n\n// The default color for elevation shadows.\n$color: black !default;\n\n// Prefix for elevation-related selectors.\n$prefix: 'mat-elevation-z';\n\n// Applies the correct css rules to an element to give it the elevation specified by $zValue.\n// The $zValue must be between 0 and 24.\n@mixin elevation($zValue, $color: $color, $opacity: null) {\n  box-shadow: get-box-shadow($zValue, $color, $opacity);\n}\n\n// Applies the elevation to an element in a manner that allows\n// consumers to override it via the Material elevation classes.\n@mixin overridable-elevation($zValue, $color: $color, $opacity: null) {\n  &:not([class*='#{$prefix}']) {\n    @include elevation($zValue, $color, $opacity);\n  }\n}\n\n// Gets the box shadow value for a specific elevation.\n@function get-box-shadow($zValue, $shadow-color: black, $opacity: null) {\n  @if $zValue == null {\n    @return null;\n  }\n\n  @if (sass-utils.is-css-var-name($zValue)) {\n    @return $zValue;\n  }\n\n  @if meta.type-of($zValue) != number or not math.is-unitless($zValue) {\n    @error '$zValue must be a unitless number, but received `#{$zValue}`';\n  }\n\n  @if $zValue < 0 or $zValue > 24 {\n    @error '$zValue must be between 0 and 24, but received `#{$zValue}`';\n  }\n\n  $umbra-z-value: map.get($_umbra-map, $zValue);\n  $penumbra-z-value: map.get($_penumbra-map, $zValue);\n  $ambient-z-value: map.get($_ambient-map, $zValue);\n\n  $color-opacity: if($opacity != null, $opacity, 1);\n  $umbra-color: _compute-color-opacity($shadow-color, $_umbra-opacity * $color-opacity);\n  $penumbra-color: _compute-color-opacity($shadow-color, $_penumbra-opacity * $color-opacity);\n  $ambient-color: _compute-color-opacity($shadow-color, $_ambient-opacity * $color-opacity);\n\n  @return string.unquote('#{$umbra-z-value} #{$umbra-color}, #{$penumbra-z-value} ' +\n          '#{$penumbra-color}, #{$ambient-z-value} #{$ambient-color}');\n}\n\n// Returns a string that can be used as the value for a transition property for elevation.\n// Calling this function directly is useful in situations where a component needs to transition\n// more than one property.\n//\n// .foo {\n//   transition: mat-elevation-transition-property-value(), opacity 100ms ease;\n// }\n@function private-transition-property-value(\n    $duration: $transition-duration,\n    $easing: $transition-timing-function) {\n  @return box-shadow #{$duration} #{$easing};\n}\n\n// Applies the correct css rules needed to have an element transition between elevations.\n// This mixin should be applied to elements whose elevation values will change depending on their\n// context (e.g. when active or disabled).\n//\n// NOTE(traviskaufman): Both this mixin and the above function use default parameters so they can\n// be used in the same way by clients.\n@mixin elevation-transition(\n    $duration: $transition-duration,\n    $easing: $transition-timing-function) {\n  transition: private-transition-property-value($duration, $easing);\n}\n\n@function _compute-color-opacity($color, $opacity) {\n  @if meta.type-of($color) == color and $opacity != null {\n    @return rgba($color, $opacity);\n  }\n  @else {\n    @return $color;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
